import PATHS from 'src/router/paths'

import discrepancy from './discrepancy'
import osi from './osi'

const columns = {
  pacing: [
    {
      align: 'start',
      class: 'advertiser-name',
      columnName: 'Advertiser',
      columnValue: (item) => item.advertiserName,
      formatAs: null,
      initialSorted: true,
      key: 'advertiserName',
      minWidth: 90,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'order-id',
      columnName: 'Order ID',
      columnValue: (item) => item.orderCode,
      exportOnly: false,
      formatAs: null,
      isLinkExternal: true,
      key: 'orderCode',
      linkProperty: 'orderGamLink',
      minWidth: 90,
      required: false,
      sortable: true,
      visible: false,
      width: 90,
    },
    {
      align: 'start',
      class: 'order-name',
      columnName: 'Order',
      columnValue: (item) => item.orderName,
      formatAs: null,
      isLinkExternal: true,
      key: 'orderName',
      linkProperty: 'orderGamLink',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'line-item-id',
      columnName: 'Line Item ID',
      columnValue: (item) => item.lineItemCode,
      exportOnly: false,
      formatAs: null,
      isLinkExternal: true,
      key: 'lineItemCode',
      linkProperty: 'lineItemGamLink',
      mergeAs: 'count',
      minWidth: 90,
      required: false,
      sortable: true,
      visible: false,
      width: 90,
    },
    {
      align: 'start',
      class: 'line-item-name',
      columnName: 'Line Item',
      columnValue: (item) => item.lineItemName,
      formatAs: null,
      isLinkExternal: true,
      key: 'lineItemName',
      linkProperty: 'lineItemGamLink',
      mergeAs: 'count',
      minWidth: 180,
      required: true,
      sortable: true,
      width: 180,
    },
    {
      align: 'end',
      class: osi.getOsiClassName.bind(osi),
      columnName: 'OSI',
      columnValue: (item) => item.osi,
      exportAs: 'percentage',
      formatAs: 'number',
      minWidth: 105,
      key: 'osi',
      required: false,
      sortable: true,
      width: 105,
    },
    {
      align: 'start',
      class: 'status',
      columnName: 'Status',
      columnValue: (item) => item.status,
      formatAs: null,
      key: 'status',
      mergeAs: 'count',
      minWidth: 130,
      required: false,
      sortable: true,
      width: 130,
    },
    {
      align: 'start',
      class: 'is-missing-creatives',
      columnName: 'Missing Creatives',
      columnValue: (item) => item.isMissingCreatives,
      formatAs: 'boolean',
      key: 'isMissingCreatives',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'creative-sizes',
      columnName: 'Sizes',
      columnValue: (item) => item.creativeSizes,
      formatAs: null,
      key: 'creativeSizes',
      minWidth: 150,
      required: false,
      sortable: true,
      tooltip: 'Creative Sizes',
      width: 150,
    },
    {
      align: 'start',
      class: 'start-date',
      columnName: 'Start Date',
      columnValue: (item) => item.startDate,
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'startDate',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'end-date',
      columnName: 'End Date',
      columnValue: (item) => item.endDate,
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'endDate',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'priority',
      columnName: 'Priority',
      columnValue: (item) => item.priority,
      formatAs: null,
      key: 'priority',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'end',
      class: 'rate',
      columnName: 'Rate',
      columnValue: (item) => item.rate,
      formatAs: 'currency',
      key: 'rate',
      minWidth: 111,
      required: false,
      sortable: true,
      width: 111,
    },
    {
      align: 'end',
      class: 'viewability-percentage',
      columnName: 'Viewability %',
      columnValue: (item) => item.viewabilityPercentage,
      exportAs: 'percentage',
      formatAs: 'percentage',
      key: 'viewabilityPercentage',
      minWidth: 135,
      required: false,
      sortable: true,
      visible: false,
      width: 135,
    },
    {
      align: 'end',
      class: 'booked',
      columnName: 'Booked',
      columnValue: (item) => item.booked,
      exportAs: 'number',
      formatAs: 'number',
      key: 'booked',
      minWidth: 135,
      required: false,
      sortable: true,
      width: 135,
    },
    {
      align: 'end',
      class: 'delivered',
      columnName: 'Delivered',
      columnValue: (item) => item.delivered,
      exportAs: 'number',
      formatAs: 'number',
      key: 'delivered',
      minWidth: 145,
      required: false,
      sortable: true,
      tooltip: 'Delivered To Date',
      width: 145,
    },
    {
      align: 'end',
      class: 'impressions-yesterday',
      columnName: 'Imps Yest',
      columnValue: (item) => item.impressionsYesterday,
      exportAs: 'number',
      formatAs: 'number',
      key: 'impressionsYesterday',
      minWidth: 145,
      required: false,
      sortable: true,
      tooltip: 'Impressions Yesterday',
      width: 145,
    },
    {
      align: 'end',
      class: 'clicks',
      columnName: 'Clicks',
      columnValue: (item) => item.clicks,
      exportAs: 'number',
      formatAs: 'number',
      key: 'clicks',
      minWidth: 120,
      required: false,
      sortable: true,
      width: 120,
    },
    {
      align: 'end',
      class: 'ctr',
      columnName: 'CTR',
      columnValue: (item) => item.ctr,
      exportAs: 'percentage',
      formatAs: 'percentage',
      key: 'ctr',
      minWidth: 120,
      required: false,
      sortable: true,
      width: 120,
    },
    {
      align: 'start',
      class: 'sales-person',
      columnName: 'Sales Person',
      columnValue: (item) => item.salespersonName || 'None',
      formatAs: null,
      key: 'salespersonName',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'trafficker',
      columnName: 'Trafficker',
      columnValue: (item) => item.traffickerName || 'None',
      formatAs: null,
      key: 'traffickerName',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'secondary-trafficker',
      columnName: 'Sec. Traffickers',
      columnValue: (item) => {
        const { secondaryTraffickerNames } = item
        return (secondaryTraffickerNames?.length && secondaryTraffickerNames) || ['None']
      },
      formatAs: null,
      key: 'secondaryTraffickerNames',
      minWidth: 180,
      required: false,
      sortable: true,
      tooltip: 'Secondary Traffickers',
      width: 180,
    },
    {
      align: 'start',
      columnName: 'Custom Fields',
      columnValue: (item) => {
        const { lineItemCustomFields, orderCustomFields } = item.normalized || {}
        const strFalsey = ['null', 'undefined']
        const normalizedOrderCustomFields = strFalsey.indexOf(orderCustomFields) !== -1 ? [] : orderCustomFields || []
        const normalizedLineItemCustomField = strFalsey.indexOf(lineItemCustomFields) !== -1 ? [] : lineItemCustomFields || []
        const customFields = normalizedOrderCustomFields.concat(normalizedLineItemCustomField)
        const getDefaultCustomFields = () => Array.isArray(customFields) && !customFields.length && ['None']
        const getCustomFields = () => Array.isArray(customFields) && customFields.map((customField) => {
          const { cf_name, cf_value } = customField
          return (cf_name && `${cf_name} = ${cf_value}`) || customField
        })

        return getDefaultCustomFields() || getCustomFields() || customFields
      },
      class: 'custom-fields',
      exportAs: (item) => ((Array.isArray(item.customFields) && item.customFields.join(', ')) || item.customFields),
      formatAs: null,
      key: 'customFields',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'end',
      class: 'all-revenue',
      columnName: 'Revenue',
      columnValue: (item) => item.allRevenue,
      formatAs: 'currency',
      key: 'allRevenue',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'end',
      class: 'potential-lost-revenue',
      columnName: 'PL $',
      columnValue: (item) => item.potentialLostRevenue,
      formatAs: 'currency',
      key: 'potentialLostRevenue',
      minWidth: 150,
      required: false,
      sortable: true,
      tooltip: 'Potential Lost Revenue',
      width: 150,
    },
    {
      align: 'end',
      class: 'potential-lost-revenue-percentage',
      columnName: 'PL %',
      columnValue: (item) => item.potentialLostRevenuePercentage,
      formatAs: 'percentage',
      key: 'potentialLostRevenuePercentage',
      minWidth: 150,
      required: false,
      sortable: true,
      tooltip: 'Potential Lost Revenue %',
      width: 150,
    },
  ],
  discrepancy: [
    {
      align: 'start',
      class: 'top-level-ad-unit-ids',
      columnName: 'Ad IDs',
      columnValue: (item) => item.topLevelAdUnitIds,
      exportOnly: false,
      formatAs: null,
      key: 'topLevelAdUnitIds',
      minWidth: 120,
      required: false,
      sortable: true,
      tooltip: 'Top-Level Ad Unit IDs',
      transform: false,
      visible: false,
      width: 120,
    },
    {
      align: 'start',
      class: 'top-level-ad-unit-names',
      columnName: 'Ad Names',
      columnValue: (item) => item.topLevelAdUnitNames,
      exportOnly: false,
      formatAs: null,
      key: 'topLevelAdUnitNames',
      minWidth: 180,
      required: false,
      sortable: true,
      tooltip: 'Top-Level Ad Unit Names',
      transform: false,
      visible: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'advertiser-code',
      columnName: 'Advertiser ID',
      columnValue: (item) => item.advertiserCode,
      exportOnly: true,
      formatAs: null,
      initialSorted: true,
      key: 'advertiserCode',
      minWidth: 105,
      required: false,
      sortable: true,
      width: 105,
    },
    {
      align: 'start',
      class: 'advertiser-name',
      columnName: 'Advertiser',
      columnValue: (item) => item.advertiserName,
      formatAs: null,
      initialSorted: true,
      key: 'advertiserName',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'order-id',
      columnName: 'Order ID',
      columnValue: (item) => item.orderCode,
      exportOnly: false,
      formatAs: null,
      isLinkExternal: true,
      key: 'orderCode',
      linkProperty: 'orderGamLink',
      minWidth: 105,
      required: false,
      sortable: true,
      visible: false,
      width: 105,
    },
    {
      align: 'start',
      class: 'order-name',
      columnName: 'Order',
      columnValue: (item) => item.orderName,
      formatAs: null,
      isLinkExternal: true,
      key: 'orderName',
      linkProperty: 'orderGamLink',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'line-item-id',
      columnName: 'Line Item ID',
      columnValue: (item) => item.lineItemCode,
      exportOnly: false,
      formatAs: null,
      isLinkExternal: true,
      key: 'lineItemCode',
      linkProperty: 'lineItemGamLink',
      minWidth: 105,
      required: false,
      sortable: true,
      visible: false,
      width: 105,
    },
    {
      align: 'start',
      class: 'line-item-name',
      columnName: 'Line Item',
      columnValue: (item) => item.lineItemName,
      formatAs: null,
      isLinkExternal: true,
      key: 'lineItemName',
      linkProperty: 'lineItemGamLink',
      minWidth: 210,
      required: true,
      sortable: true,
      width: 210,
    },
    {
      align: 'end',
      class: 'start-date',
      columnName: 'Start Date',
      columnValue: (item) => item.startDate,
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'startDate',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'end',
      class: 'end-date',
      columnName: 'End Date',
      columnValue: (item) => item.endDate,
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'endDate',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'end',
      class: 'osi',
      columnName: 'OSI',
      columnValue: (item) => item.osi,
      exportAs: 'percentage',
      formatAs: 'number',
      key: 'osi',
      minWidth: 105,
      required: false,
      sortable: true,
      width: 105,
    },
    {
      align: 'end',
      class: 'first-party-delivered',
      columnName: '1st Party Delivered',
      columnValue: (item) => item.localImps,
      exportAs: 'number',
      formatAs: 'number',
      key: 'localImps',
      minWidth: 189,
      required: false,
      sortable: true,
      width: 189,
    },
    {
      align: 'end',
      class: 'third-party-delivered',
      columnName: '3rd Party Delivered',
      columnValue: (item) => item.thirdPartyImps,
      exportAs: 'number',
      formatAs: 'number',
      key: 'thirdPartyImps',
      minWidth: 189,
      required: false,
      sortable: true,
      width: 189,
    },
    {
      align: 'end',
      class: 'first-party-clicks',
      columnName: '1st Party Clicks',
      columnValue: (item) => item.localClicks,
      exportAs: 'number',
      formatAs: 'number',
      key: 'localClicks',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'end',
      class: 'third-party-clicks',
      columnName: '3rd Party Clicks',
      columnValue: (item) => item.thirdPartyClicks,
      exportAs: 'number',
      formatAs: 'number',
      key: 'thirdPartyClicks',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'end',
      class: discrepancy.getDiscrepancyClassName.bind(discrepancy),
      columnName: 'Discrepancy',
      columnValue: (item) => {
        const { discrepancyPercentage } = item
        const maxInt = '2147483647'

        return discrepancyPercentage === maxInt ? 'N/A' : discrepancyPercentage
      },
      formatAs: 'discrepancyPercentage',
      key: 'discrepancyPercentage',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'status',
      columnName: 'Status',
      columnValue: (item) => item.status,
      formatAs: null,
      key: 'status',
      mergeAs: 'count',
      minWidth: 130,
      required: false,
      sortable: true,
      width: 130,
    },
    {
      align: 'start',
      class: 'is-missing-creatives',
      columnName: 'Missing Creatives',
      columnValue: (item) => item.isMissingCreatives,
      formatAs: 'boolean',
      key: 'isMissingCreatives',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'creative-sizes',
      columnName: 'Sizes',
      columnValue: (item) => item.creativeSizes,
      formatAs: null,
      key: 'creativeSizes',
      minWidth: 150,
      required: false,
      sortable: true,
      tooltip: 'Creative Sizes',
      width: 150,
    },
    {
      align: 'end',
      class: 'rate',
      columnName: 'Rate',
      columnValue: (item) => item.rate,
      formatAs: 'currency',
      key: 'rate',
      minWidth: 111,
      required: false,
      sortable: true,
      width: 111,
    },
    {
      align: 'start',
      class: 'frequency-cap',
      columnName: 'Frequency Cap',
      columnValue: (item) => item.gamFreqCap,
      formatAs: null,
      key: 'gamFreqCap',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'start',
      class: 'priority',
      columnName: 'Priority',
      columnValue: (item) => item.gamPriority,
      formatAs: null,
      key: 'gamPriority',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'end',
      class: 'goal',
      columnName: 'Goal',
      columnValue: (item) => item.goal,
      exportAs: 'number',
      formatAs: 'number',
      key: 'goal',
      minWidth: 145,
      required: false,
      sortable: true,
      tooltip: null,
      width: 145,
    },
    {
      align: 'start',
      class: 'viewable-impressions',
      columnName: 'Viewable Imps',
      columnValue: (creativeItem) => creativeItem.viewableImpressions,
      exportAs: 'number',
      formatAs: 'number',
      key: 'viewableImpressions',
      minWidth: 145,
      required: false,
      sortable: true,
      tooltip: 'Viewable Impressions',
      width: 145,
    },
    {
      align: 'end',
      class: 'impressions-yesterday',
      columnName: 'Imps Yest',
      columnValue: (item) => item.impressionsYesterday,
      exportAs: 'number',
      formatAs: 'number',
      key: 'impressionsYesterday',
      minWidth: 145,
      required: false,
      sortable: true,
      tooltip: 'Impressions Yesterday',
      width: 145,
    },
    {
      align: 'end',
      class: 'ctr',
      columnName: 'CTR',
      columnValue: (item) => item.ctr,
      exportAs: 'percentage',
      formatAs: 'percentage',
      key: 'ctr',
      minWidth: 120,
      required: false,
      sortable: true,
      width: 120,
    },
    {
      align: 'start',
      class: 'sales-person',
      columnName: 'Sales Person',
      columnValue: (item) => item.salespersonName || 'None',
      formatAs: null,
      key: 'salespersonName',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'trafficker',
      columnName: 'Trafficker',
      columnValue: (item) => item.traffickerName || 'None',
      formatAs: null,
      key: 'traffickerName',
      minWidth: 180,
      required: false,
      sortable: true,
      width: 180,
    },
    {
      align: 'start',
      class: 'secondary-trafficker',
      columnName: 'Sec. Traffickers',
      columnValue: (item) => {
        const { secondaryTraffickerNames } = item
        return (secondaryTraffickerNames?.length && secondaryTraffickerNames) || ['None']
      },
      formatAs: null,
      key: 'secondaryTraffickerNames',
      minWidth: 180,
      required: false,
      sortable: true,
      tooltip: 'Secondary Traffickers',
      width: 180,
    },
    {
      align: 'end',
      class: 'all-revenue',
      columnName: 'Revenue',
      columnValue: (item) => item.allRevenue,
      formatAs: 'currency',
      key: 'allRevenue',
      minWidth: 150,
      required: false,
      sortable: true,
      width: 150,
    },
    {
      align: 'end',
      class: 'potential-lost-revenue',
      columnName: 'PL $',
      columnValue: (item) => item.potentialLostRevenue,
      formatAs: 'currency',
      key: 'potentialLostRevenue',
      minWidth: 150,
      required: false,
      sortable: true,
      tooltip: 'Potential Lost Revenue',
      width: 150,
    },
    {
      align: 'end',
      class: 'potential-lost-revenue-percentage',
      columnName: 'PL %',
      columnValue: (item) => item.potentialLostRevenuePercentage,
      formatAs: 'percentage',
      key: 'potentialLostRevenuePercentage',
      minWidth: 150,
      required: false,
      sortable: true,
      tooltip: 'Potential Lost Revenue %',
      width: 150,
    },
  ],
  creatives: [
    {
      align: 'start',
      class: 'creative-server',
      columnName: 'Creative Server',
      columnValue: (item) => item.thirdPartyServer,
      formatAs: null,
      key: 'thirdPartyServer',
      sortable: true,
    },
    {
      align: 'start',
      class: 'creative-code',
      columnName: 'Creative ID',
      columnValue: (item) => item.creativeCode,
      isLinkExternal: true,
      formatAs: null,
      key: 'creativeCode',
      linkProperty: 'creativeGamLink',
      sortable: true,
    },
    {
      align: 'start',
      class: 'creative-name',
      columnName: 'Creative Name',
      formatAs: null,
      key: 'creativeName',
      sortable: true,
      columnValue: (item) => item.creativeName,
    },
    {
      align: 'start',
      class: 'creative-third-party-impressions',
      columnName: 'Imps',
      exportAs: 'number',
      formatAs: 'number',
      key: 'thirdPartyImps',
      sortable: true,
      columnValue: (item) => item.thirdPartyImps,
    },
    {
      align: 'start',
      class: 'creative-third-party-clicks',
      columnName: 'Clicks',
      exportAs: 'number',
      formatAs: 'number',
      key: 'thirdPartyClicks',
      sortable: true,
      columnValue: (item) => item.thirdPartyClicks,
    },
    {
      align: 'start',
      class: 'creative-local-imps',
      columnName: '1st Party Imps',
      exportAs: 'number',
      formatAs: 'number',
      key: 'localImps',
      sortable: true,
      columnValue: (item) => item.localImps,
    },
    {
      align: 'start',
      class: 'creative-local-clicks',
      columnName: '1st Party Clicks',
      exportAs: 'number',
      formatAs: 'number',
      key: 'localClicks',
      sortable: true,
      columnValue: (item) => item.localClicks,
    },
    {
      align: 'start',
      class: discrepancy.getDiscrepancyClassName,
      columnName: 'Discrepancy',
      formatAs: 'discrepancyPercentage',
      key: 'discrepancyPercentage',
      sortable: true,
      columnValue: (item) => {
        const { discrepancyPercentage } = item
        const maxInt = '2147483647'

        if (discrepancyPercentage === maxInt) {
          return 'N/A'
        }

        return discrepancyPercentage
      },
    },
  ],
  creativesReport: [
    {
      align: 'start',
      class: 'creative-name',
      columnName: 'Creative Name',
      exportOnly: true,
      formatAs: null,
      key: 'creativeName',
      sortable: true,
      columnValue: (item) => item.creativeName,
    },
    {
      align: 'start',
      class: 'creative-code',
      columnName: 'Creative Code',
      exportOnly: true,
      formatAs: null,
      key: 'creativeCode',
      sortable: true,
      columnValue: (item) => item.creativeCode,
    },
    {
      align: 'start',
      class: 'creative-id',
      columnName: 'Creative Id',
      exportOnly: true,
      formatAs: null,
      key: 'creativeId',
      sortable: true,
      columnValue: (item) => item.creativeId,
    },
    {
      align: 'start',
      class: 'creative-size',
      columnName: 'Creative Size',
      exportOnly: true,
      formatAs: null,
      key: 'creativeSize',
      sortable: true,
      columnValue: (item) => item.creativeSize,
    },
    {
      align: 'start',
      class: 'date',
      columnName: 'Date',
      formatAs: 'date',
      key: 'date',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.date,
    },
    {
      align: 'start',
      class: 'impressions',
      columnName: 'Imps',
      exportAs: 'number',
      formatAs: 'number',
      key: 'impressions',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.impressions,
    },
    {
      align: 'start',
      class: 'viewable-impressions',
      columnName: 'Viewable Imps',
      exportAs: 'number',
      formatAs: 'number',
      key: 'viewableImpressions',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.viewableImpressions,
    },
    {
      align: 'start',
      class: 'viewability',
      columnName: 'Viewability',
      formatAs: 'percentage',
      key: 'viewabilityPercentage',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.viewabilityPercentage,
    },
    {
      align: 'start',
      class: 'clicks',
      columnName: 'Clicks',
      exportAs: 'number',
      formatAs: 'number',
      key: 'clicks',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.clicks,
    },
    {
      align: 'start',
      class: 'ctr',
      columnName: 'CTR',
      exportAs: 'percentage',
      formatAs: 'percentage',
      key: 'ctr',
      sortable: true,
      columnValue: (creativeItem) => creativeItem.ctr,
    },
  ],
  [PATHS.REPORTS.ADX_HEALTH]: [
    {
      align: 'start',
      class: 'date',
      columnName: 'Date',
      columnValue: (item) => item.date,
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'date',
      sortable: true,
      tooltip: 'Date',
      transform: false,
      width: 120,
    },
    {
      align: 'start',
      class: 'top-level-ad-unit-code',
      columnName: 'Ad ID',
      columnValue: (item) => item.topLevelAdUnitCode,
      exportOnly: false,
      key: 'topLevelAdUnitCode',
      sortable: true,
      tooltip: 'Top-Level Ad Unit ID',
      transform: false,
      visible: false,
      width: 120,
    },
    {
      align: 'start',
      class: 'top-level-ad-unit-name',
      columnName: 'Ad Name',
      columnValue: (item) => item.topLevelAdUnitName,
      key: 'topLevelAdUnitName',
      sortable: true,
      tooltip: 'Top-Level Ad Unit Name',
      transform: false,
      width: 180,
    },
    {
      align: 'start',
      class: 'device-category',
      columnName: 'Device',
      columnValue: (item) => item.deviceCategory,
      key: 'deviceCategory',
      sortable: true,
      tooltip: 'Device Category',
      transform: false,
      width: 120,
    },
    {
      align: 'start',
      class: 'inventory-size',
      columnName: 'Size',
      columnValue: (item) => {
        const { inventorySize } = item
        if (!inventorySize) return 'Not Set'
        if (Array.isArray(inventorySize)) return inventorySize.join(', ')
        return inventorySize
      },
      key: 'inventorySize',
      sortable: true,
      tooltip: 'Size',
      transform: "(value) => value.split(',')",
      width: 180,
    },
    {
      align: 'start',
      class: 'ad-requests',
      columnName: 'Ad Requests',
      columnValue: (item) => item.adRequests,
      exportAs: 'number',
      formatAs: 'number',
      key: 'adRequests',
      sortable: true,
      tooltip: 'Ad Requests',
      transform: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'matched-requests',
      columnName: 'Matched Requests',
      columnValue: (item) => item.matchedRequests,
      exportAs: 'number',
      formatAs: 'number',
      key: 'matchedRequests',
      sortable: true,
      tooltip: 'Matched Requests',
      transform: false,
      width: 186,
    },
    {
      align: 'start',
      class: 'coverage',
      columnName: 'Coverage',
      columnValue: (item) => item.coverage,
      formatAs: 'percentage',
      key: 'coverage',
      sortable: true,
      tooltip: 'Coverage',
      transform: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'ad-impressions',
      columnName: 'Impressions',
      columnValue: (item) => item.adImpressions,
      exportAs: 'number',
      formatAs: 'number',
      key: 'adImpressions',
      sortable: true,
      tooltip: 'Impressions',
      transform: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'ad-impressions-percentage',
      columnName: 'Imps %',
      columnValue: (item) => item.adImpressionPerc,
      formatAs: 'percentage',
      key: 'adImpressionPerc',
      sortable: true,
      tooltip: 'Impressions %',
      transform: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'ad-ecpm',
      columnName: 'eCPM',
      columnValue: (item) => item.adEcpm,
      formatAs: 'currency',
      key: 'adEcpm',
      sortable: true,
      tooltip: 'eCPM',
      transform: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'estimated-revenue',
      columnName: 'Est. Revenue',
      columnValue: (item) => item.estimatedRevenue,
      formatAs: 'dollars',
      key: 'estimatedRevenue',
      sortable: true,
      tooltip: 'Estimated Revenue',
      transform: false,
      width: 150,
    },
  ],
  [PATHS.REPORTS.NETWORK_HEALTH]: [
    {
      align: 'start',
      class: 'date',
      columnName: 'Date',
      columnValue: (item) => item.date,
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'date',
      sortable: true,
      tooltip: 'Date',
      transform: false,
      width: 120,
    },
    {
      align: 'start',
      class: 'ad-unit-code',
      columnName: 'Ad ID',
      columnValue: (item) => item.topLevelAdUnitCode,
      exportOnly: false,
      key: 'topLevelAdUnitCode',
      sortable: true,
      tooltip: 'Top-Level Ad Unit ID',
      transform: false,
      visible: false,
      width: 120,
    },
    {
      align: 'start',
      class: 'ad-unit-name',
      columnName: 'Ad Name',
      columnValue: (item) => item.topLevelAdUnitName,
      key: 'topLevelAdUnitName',
      sortable: true,
      tooltip: 'Top-Level Ad Unit Name',
      transform: false,
      width: 180,
    },
    {
      align: 'start',
      class: 'device-category',
      columnName: 'Device',
      columnValue: (item) => item.deviceCategoryName,
      key: 'deviceCategoryName',
      sortable: true,
      tooltip: 'Device Category',
      transform: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'requested-ad-sizes',
      columnName: 'Requested Sizes',
      columnValue: (item) => {
        const { requestedAdSizes } = item
        if (!requestedAdSizes) return 'Not Set'
        if (Array.isArray(requestedAdSizes)) return requestedAdSizes.join(', ')
        return requestedAdSizes
      },
      key: 'requestedAdSizes',
      sortable: true,
      tooltip: 'Requested Sizes',
      transform: "(value) => value.split(',')",
      width: 212,
    },
    {
      align: 'start',
      class: 'unfilled-impressions',
      columnName: 'Unfilled Imps',
      columnValue: (item) => item.unfilledImpressions,
      exportAs: 'number',
      formatAs: 'number',
      key: 'unfilledImpressions',
      sortable: true,
      tooltip: 'Unfilled Impressions. Sourced from GAM.',
      transform: false,
      width: 153,
    },
    {
      align: 'start',
      class: 'total-impressions',
      columnName: 'Total Imps',
      columnValue: (item) => item.totalImpressions,
      exportAs: 'number',
      formatAs: 'number',
      key: 'totalImpressions',
      sortable: true,
      tooltip: 'Total Imps',
      transform: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'all-impressions',
      columnName: 'All Imps',
      columnValue: (item) => item.allImpressions,
      exportAs: 'number',
      formatAs: 'number',
      key: 'allImpressions',
      sortable: true,
      tooltip: 'All Impressions',
      transform: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'unfilled-percentage',
      columnName: 'Unfilled %',
      columnValue: (item) => item.unfilledPercentage,
      formatAs: 'percentage',
      key: 'unfilledPercentage',
      sortable: true,
      tooltip: 'Unfilled Percentage',
      transform: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'gross-revenue',
      columnName: 'Est. Revenue',
      columnValue: (item) => item.revenue,
      formatAs: 'dollars',
      key: 'revenue',
      sortable: true,
      tooltip: 'Estimated Revenue. Sourced from GAM.',
      transform: false,
      width: 150,
    },
  ],
  [PATHS.REPORTS.YIELD_PARTNER]: [
    {
      align: 'start',
      class: 'date',
      columnName: 'Date',
      columnValue: (item) => item.date,
      exportAs: ['date', 'L'],
      formatAs: 'date',
      key: 'date',
      sortable: true,
      tooltip: 'Date',
      transform: false,
      width: 120,
    },
    {
      align: 'start',
      class: 'week',
      columnName: 'Week',
      columnValue: (item) => item.week,
      formatAs: 'number',
      key: 'week',
      sortable: true,
      tooltip: 'Week',
      transform: false,
      visible: false,
      width: 90,
    },
    {
      align: 'start',
      class: 'demand-channel-code',
      columnName: 'DCID',
      columnValue: (item) => item.demandChannelCode,
      key: 'demandChannelCode',
      sortable: true,
      tooltip: 'DCID',
      transform: false,
      visible: false,
      width: 102,
    },
    {
      align: 'start',
      class: 'demand-channel-name',
      columnName: 'Demand Channel',
      columnValue: (item) => item.demandChannelName,
      key: 'demandChannelName',
      sortable: true,
      tooltip: 'Demand Channel',
      transform: false,
      width: 180,
    },
    {
      align: 'start',
      class: 'yield-partner',
      columnName: 'Yield Partner',
      columnValue: (item) => {
        const { yieldPartner } = item
        const isGoogle = yieldPartner === null
        return isGoogle ? 'Google' : String(yieldPartner)
      },
      key: 'yieldPartner',
      sortable: true,
      tooltip: 'Yield Partner',
      transform: false,
      width: 160,
    },
    {
      align: 'start',
      class: 'yield-impressions',
      columnName: 'Impressions',
      columnValue: (item) => item.yieldImpressions,
      exportAs: 'number',
      formatAs: 'number',
      key: 'yieldImpressions',
      sortable: true,
      tooltip: 'Impressions',
      transform: false,
      width: 160,
    },
    {
      align: 'start',
      class: 'yield-ecpm',
      columnName: 'eCPM',
      columnValue: (item) => item.yieldEstimatedCPM,
      formatAs: 'currency',
      key: 'yieldEstimatedCPM',
      sortable: true,
      tooltip: 'eCPM',
      transform: false,
      width: 150,
    },
    {
      align: 'start',
      class: 'yield-revenue',
      columnName: 'Revenue',
      columnValue: (item) => item.yieldEstimatedRevenue,
      formatAs: 'dollars',
      key: 'yieldEstimatedRevenue',
      sortable: true,
      tooltip: 'Revenue',
      transform: false,
      width: 160,
    },
  ],
}

export default columns
